import React from "react";
import styles from "./InformationCard.module.css";
import clsx from "clsx";
import RedirectCircleView from "./RedirectCircleView";
import { getResponsiveBgImage } from "../util/ExtensionFunction";

interface InformationCardProps {
  title: string;
  paragraph: string;
  srcImage: string[];
  buttonName: string;
  informationTextAlign: InformationTextAlign;
  onClick?: () => void;
  isDisable?: boolean;
  moveBottomImageTop?: boolean | null;
  isHovered?: boolean;
}

export enum InformationTextAlign {
  Top = "Top",
  Bottom = "Bottom",
}

const InformationCard: React.FC<InformationCardProps> = ({
  title,
  paragraph,
  srcImage,
  // buttonName,
  informationTextAlign,
  onClick,
  isDisable,
  moveBottomImageTop = false,
  isHovered,
}) => {
  const getAlignStyle = (alignStyle: InformationTextAlign) => {
    switch (alignStyle) {
      case InformationTextAlign.Top:
        return styles["top"];
      case InformationTextAlign.Bottom:
        return styles["bottom"];
      default:
        return styles["bottom"];
    }
  };

  return (
    <div
      className={clsx(
        styles["card-info-container"],
        informationTextAlign == InformationTextAlign.Top && styles["bottom"],
        informationTextAlign == InformationTextAlign.Top &&
          moveBottomImageTop &&
          styles["bottom-top"]
      )}
      style={{ backgroundImage: `url(${getResponsiveBgImage(srcImage)})` }}
    >
      <div
        className={clsx(
          styles["card-info-text-container"],
          getAlignStyle(informationTextAlign)
        )}
      >
        <div
          className={clsx(
            styles["card-info-text-holder"],
            informationTextAlign == InformationTextAlign.Top
              ? styles["top"]
              : styles["bottom"]
          )}
        >
          <div>
            <div className={styles["card-info-title"]}>{title}</div>
            <div className={styles["card-info-description"]}>{paragraph}</div>
          </div>
          {!isDisable && (
            <div
              className={clsx(
                styles["card-info-button"],
                informationTextAlign == InformationTextAlign.Bottom &&
                  styles["bottom"]
              )}
            >
              <RedirectCircleView onClick={onClick} isHovered={isHovered} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default InformationCard;
